import { render, staticRenderFns } from "./HelperComissao.vue?vue&type=template&id=5af45f58&lang=pug"
import script from "./HelperComissao.vue?vue&type=script&lang=js"
export * from "./HelperComissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports